import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import s from './FavoriteInput.less'
import classNames from 'classnames'
import { suggestServiceCtx } from '../../../../store/suggest/suggest.service.constants'
import { setSuggestInputValue, suggest } from '../../../../store/suggest/suggest.actions'
import { useAction } from '../../../utils/react-redux'
import useDebounce from '../../../utils/useDebounce'

const FavoriteInput = forwardRef((props, ref) => {
  const { value, onChange, className, placeholder } = props

  const suggestFilterType = suggestServiceCtx.filter.places
  const execSuggest = useAction(suggest)
  const execSetInputValue = useAction(setSuggestInputValue)
  const [cancelSuggest, setCancelSuggest] = useState(false)
  const inputRef = useRef()
  const debouncedValue = useDebounce(value, 250)
  const hasDebouncedValueChangeOnce = useRef(false) // to ignore suggest on first render

  const onSubmit = useCallback(() => {
    execSetInputValue(value)
    setCancelSuggest(true)
    return Promise.resolve().then(() => blur())
  }, [value])

  useImperativeHandle(ref, () => {
    return { onSubmit }
  })

  const doSuggest = val => {
    if (cancelSuggest) {
      setCancelSuggest(false)
      return Promise.resolve()
    }
    execSetInputValue(val)
    return execSuggest({ terms: val, suggestFilterType })
  }

  useEffect(() => {
    if (hasDebouncedValueChangeOnce.current) {
      doSuggest(debouncedValue)
    }
    hasDebouncedValueChangeOnce.current = true
  }, [debouncedValue])

  const handleChange = event => {
    onChange && onChange({ value: event.target.value })
  }

  const handleFocus = e => {
    e.target.select()
    doSuggest(value)
  }

  const blur = () => inputRef && inputRef.current.blur()

  return (
    <div className={classNames(s.container, className)}>
      <input
        ref={inputRef}
        type="text"
        id="favoriteInput"
        value={value}
        className={s.field}
        placeholder={placeholder}
        onFocus={handleFocus}
        onChange={handleChange}
        autoComplete="off"
        autoFocus
      />
    </div>
  )
})

FavoriteInput.displayName = 'FavoriteInput'
export default FavoriteInput
